import React from 'react';
import { Route } from 'react-router-dom';
import DeclareSinistre from '../pages/sinistres/DeclareSinistre';
import ListSinistres from '../pages/sinistres/ListSinistres';
import DetailsSinistre from '../pages/sinistres/details/DetailsSinistre';
import DetailsSinistreV2 from '../pages/sinistres/details/DetailsSinistreV2';
import EvaluationSinistre from '../pages/sinistres/details/EvaluationSinistre';
import ValidationDecaissements from '../pages/sinistres/ValidationDecaissements';
import ValidationEvaluations from '../pages/sinistres/ValidationEvaluations';
import GestionPaiementSinistreExperts from '../pages/sinistres/GestionPaiementSinistreExperts';

const SinistreRoutes = () => (
    <>
        <Route path="/declare-sinister" element={<DeclareSinistre />} />
        <Route path="/declarer-sinister" element={<DeclareSinistre />} />
        <Route path="/liste-des-sinistres" element={<ListSinistres />} />
        <Route path="/details-sinistre" element={<DetailsSinistre />} />
        <Route path="/details-sinistre-v2" element={<DetailsSinistreV2 />} />
        <Route path="/evaluation-sinistre" element={<EvaluationSinistre />} />
        <Route path="/validation-decaissement" element={<ValidationDecaissements />} />
        <Route path="/validation-evaluation" element={<ValidationEvaluations />} />
        <Route path="/paiements-sinistre-expert" element={<GestionPaiementSinistreExperts />} />
    </>
);

export default SinistreRoutes;
